import React from "react";
import PropTypes from "prop-types";

const Radio = props => {
	return (
		<div className="default-radio">
			<p>
				{props.item.caption}
				{props.item.required ? "*" : ""}
			</p>
			{props.item.data.map((it, itId) => {
				return (
					<div key={`radio-${props.item.name}-${it.id}`} className="option-holder">
						<input
							type="radio"
							name={props.item.name}
							id={it.id}
							onClick={e => {
								props.setValue(props.item.name, it.id);
							}}></input>
						<label htmlFor={it.id}>{it.label}</label>
					</div>
				);
			})}
		</div>
	);
};

Radio.propTypes = {
	item: PropTypes.object,
	attributes: PropTypes.func,
	setValue: PropTypes.func
};

export default Radio;
